export default __webpack_public_path__ + "static/media/tj_white_icon.cca798ac.svg";